export default function DownloadCTA() {
  return (
    <section id="download" className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20flowing%20shapes%20in%20coral%20orange%20and%20warm%20cream%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20organic%20curves%2C%20gentle%20color%20blending%2C%20digital%20art%20style%2C%20airy%20and%20elegant%20composition&width=1800&height=900&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">
            下载蘑菇视频App
          </h2>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
            随时随地观看精彩短视频，发现更多有趣内容。<br />
            支持 iOS 和 Android，免费下载使用。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="flex items-center gap-3 px-8 py-4 bg-white rounded-xl text-foreground-950 font-medium hover:bg-white/90 transition-all duration-200 whitespace-nowrap group cursor-pointer"
            >
              <i className="ri-apple-line text-2xl"></i>
              <div className="text-left">
                <div className="text-xs text-foreground-500">Download on the</div>
                <div className="text-base font-semibold">App Store</div>
              </div>
            </a>
            <a
              href="#"
              className="flex items-center gap-3 px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white font-medium hover:bg-white/20 transition-all duration-200 whitespace-nowrap group cursor-pointer"
            >
              <i className="ri-android-line text-2xl"></i>
              <div className="text-left">
                <div className="text-xs text-white/60">Download for</div>
                <div className="text-base font-semibold">Android</div>
              </div>
            </a>
          </div>

          <div className="mt-8 flex items-center justify-center gap-8 text-white/60">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">5000万+</div>
              <div className="text-xs mt-1">累计下载</div>
            </div>
            <div className="w-px h-10 bg-white/20" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">4.8</div>
              <div className="text-xs mt-1">用户评分</div>
            </div>
            <div className="w-px h-10 bg-white/20" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">98%</div>
              <div className="text-xs mt-1">好评率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}